<script>
import _ from "lodash";
import {mapActions, mapState} from "vuex";
import AmsuScholarshipCard from "../AmsuScholarshipCard.vue";
import MeetingVoteCommentCard from "./MeetingVoteCommentCard.vue";
import moment from "moment";

export default {
  name: "MeetingScholarshipAchievementCard",
  components: {MeetingVoteCommentCard, AmsuScholarshipCard},

  props: {
    achievement: Object,

    isActionPresent: {
      type: Boolean,
      default: true,
    }
  },

  data() {
    return {
      loadingAchievement: false,
      menu: false,
    };
  },

  computed: {

    ...mapState({
      statement: state => state.scholarship_competition.statement,
    }),

    typeAchievement() {
      return this.achievement.prtf_achievement_type_name;
    },

    kindAchievement() {
      return this.achievement.prtf_achievement_kind_name;
    },

    nameAchievement() {
      return this.achievement.name;
    },

    scoreUnit() {
      const achievement = this.achievement;

      if (_.isNil(achievement.subunit)) return achievement.unit?.score;
      return achievement.subunit?.score;
    },

    nameUnit() {
      const achievement = this.achievement;

      if (!_.isNil(achievement.subunit) && !_.isNil(achievement.subunit)) return `${achievement?.unit?.name}/${achievement?.subunit?.name}`;
      if (_.isNil(achievement.subunit)) return achievement.unit?.name;
      return achievement.subunit?.name;
    },

    achievementDate() {
      if (_.isNil(this.achievement?.date_end)) return "";
      return moment(this.achievement?.date_end).format('DD.MM.YYYY');
    },

    fileUrl() {
      return this.achievement.file.url;
    },

    achievementID() {
      return this.achievement.id;
    },

    isAchievementPresent() {
      return this.achievement.comments.length > 0;
    },

  },

  methods: {
    ...mapActions({
      deleteAchievementFromStatement: "scholarship_competition/deleteAchievementFromStatement",

      openDialog: "scholarship_comment/openDialog",
    }),
  }

}
</script>

<template>
  <v-card flat>
    <v-card-text class="py-1 pb-2 px-2">
      <v-list-item three-line>
        <v-list-item-icon class="mr-3 mb-1">
          <v-btn
            outlined
            icon
            class="rounded-circle pa-2"
            large
            :href="fileUrl"
            target="_blank"
          >
            <v-icon>fa-file</v-icon>
          </v-btn>
        </v-list-item-icon>

        <v-list-item-content>

          <v-list-item-subtitle
            class="font-weight-bold teal-darken-3 d-flex text-wrap"
          >
            Деятельность: {{ typeAchievement }}
          </v-list-item-subtitle>

          <v-list-item-subtitle
            class="font-weight-bold teal-darken-3 d-flex text-wraps"
          >
            Вид достижения: {{ kindAchievement }}
          </v-list-item-subtitle>

          <v-list-item-title>
            Название: <span class="font-weight-bold color-title-list">{{nameAchievement}}</span>
          </v-list-item-title>

        </v-list-item-content>
      </v-list-item>

      <v-list-item class="mt-0 pt-0">
        <v-list-item-content class="mt-0 pt-0">
          <v-list-item-title>
            Критерий: {{nameUnit}}
          </v-list-item-title>
          <v-list-item-subtitle class="font-weight-bold">
            Баллы: <span class="color-title-list">{{scoreUnit}}</span>
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-card-actions class="pa-0 ma-0">
        <v-btn
          color="teal darken-3"
          small
          class="rounded-xl white--text"
          :loading="loadingAchievement"
          @click="$emit('openAchievement', achievement)"
        >
          Просмотр
        </v-btn>

        <template v-if="isActionPresent">
          <v-btn
            outlined
            color="warning"
            small
            class="rounded-xl"
            :loading="loadingAchievement"
            @click="openDialog({achievementId: achievementID, competitionId: statement.id})"
            :disabled="isAchievementPresent"
          >
            Удалить
          </v-btn>
          <v-btn
            color="teal darken-3"
            small
            outlined
            class="rounded-xl"
            :disabled="isAchievementPresent"
            @click="$emit('openEditAchievement', achievement)"
          >
            Ред-ть
            <v-icon right small>
              fa-edit
            </v-icon>
          </v-btn>

          <v-btn
            color="error"
            small
            outlined
            class="rounded-xl ml-2"
            @click="$emit('openAchievement', achievement)"
            v-show="isAchievementPresent"
          >
            Ком-ий
            <v-icon right small>
              fa-comment
            </v-icon>
          </v-btn>
        </template>

        <v-spacer/>
        <v-chip color="teal darken-3" class="white--text" small>{{achievementDate}}</v-chip>
      </v-card-actions>

    </v-card-text>

  </v-card>
</template>

<style scoped>
.color-title-list {
  color: #00695C;
}
</style>